import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import Auctions from 'pages/market/new-signings/page';

const Column = styled(Vertical)`
  padding: 0 var(--triple-unit);
`;

const MobileNewSigningsPage = () => {
  return (
    <Column>
      <Auctions />
    </Column>
  );
};

export default MobileNewSigningsPage;
